<script>
  import { HStack, VStack, Spacer, Fixed, MediaQuery } from "./layout";
  import { Icon, Button } from "./widget";
  import { navigate } from "../router";
  import { count } from "../mailing.js";

  export let guid;

  const extractCount = (mailings, type) => {
    let m = mailings.find((e) => e.type == type);
    return m ? m.count : 0;
  };

  const doit = () => navigate(`#/mailing/${guid}`);
</script>

<article>
  <MediaQuery query="(min-width: 481px)">
    <VStack alignment="stretch">
      <HStack>
        <Spacer />
        <img src="/images/ic_coeurVertx4.png" alt="RSVP" width="48px" />
        <Spacer />
      </HStack>
      <HStack>
        <Spacer />
        {#await count(guid) then mailings}
          <VStack>
            <div>Annonces/Mailings</div>
            <span>
              Save the date&nbsp;envoyés:
              <span class="value">{extractCount(mailings, "STD")}</span>
            </span>
            <span>
              Faire-Parts envoyés&nbsp;:
              <span class="value">{extractCount(mailings, "FP")}</span>
            </span>
            <span>
              Total réponses reçues&nbsp;:
              <span class="value">{extractCount(mailings, "RSVP")}</span>
            </span>
            <span>
              Remerciements envoyés&nbsp;:
              <span class="value">{extractCount(mailings, "THX")}</span>
            </span>
            <button class="primary" on:click={doit}>Envoyer</button>
          </VStack>
        {/await}
        <Spacer />
      </HStack>
    </VStack>
  </MediaQuery>
  <MediaQuery query="(max-width: 480px)">
    <Button action={doit}>
      <HStack alignment="center">
        <img src="/images/ic_coeurVertx4.png" alt="RSVP" width="48px" />
        <span>Annonces/Mailings</span>
        <Spacer />
        <Icon name="chevron-right" />
        <Fixed />
      </HStack>
    </Button>
  </MediaQuery>
</article>

<style>
  article {
    width: 100%;
    min-height: 48px;
    background-color: white;
    margin-top: 5px;
    padding-top: 5px;
  }
  span {
    margin-left: 1em;
  }
  @media (min-width: 481px) {
    article {
      padding: 1em;
      width: fit-content;
      min-width: 200px;
    }
    span {
      font-size: small;
      line-height: 2em;
    }
    span.value {
      color: var(--primary-light-color);
    }
  }
</style>
